import { useRouter } from 'next/router';
import { useCallback } from 'react';

export const useNumberFormatter = (options = {}) => {
  const { locale } = useRouter();
  const formatter = Intl.NumberFormat(locale, options);

  return useCallback((value) => formatter.format(value), [formatter]);
};
